import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-morder-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.scss']
})
export class MorderDetailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  	$("#mmypage-menu3").addClass("active");
  }

}
